/* global window, document */
/* eslint no-underscore-dangle: 0 */
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Raven from 'raven-js';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import App from './App';
import './styles';
import createStore from './redux';
import { loadState } from './utils/persist';

if (process.env.NODE_ENV === 'production') {
    console.log('init raven');
    Raven.config('https://2240a35ef9b54adb8b5e5a44249f3c3b@sentry.io/189071', {
        environment: process.env.NODE_ENV,
        serverName: window.location.hostname,
    }).install();
}

const state = loadState();

const store = createStore(
    state,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

const Main = () => (
    <Provider store={store}>
        <Router>
            <Route component={App} />
        </Router>
    </Provider>
);

ReactDOM.render(
    <Main />,
    document.getElementById('root'),
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/